// removed by extract-text-webpack-plugin
module.exports = {"root":"root--055a0","message":"message--233c0"};